import { useState } from 'react';
import config from '../../utils/apiUrl';

const useCreateRecurrence = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    const createRecurrence = async (paymentData) => {
        setLoading(true);
        setError(null);
    
        try {
        const endpoint = '/companyRecurringPayments/create';
    
        const body = {
          userId: paymentData.userId,
          foundationId: paymentData.foundation,
          amount: paymentData.amount,
          creditCardMask: paymentData.creditCardMask,
          campaignId: paymentData.campaign,
          creditCardBrand: paymentData.cardBrand || '',
          company: 'titan',
        };
    
        const response = await fetch(`${config.apiUrl}${endpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        const data = await response.json();
    
        if (!data.success) {
            throw new Error(data.message || 'Error creando la transacción');
        }
        return data.reference;
        } catch (err) {
        setError(err.message);
        throw err;
        } finally {
        setLoading(false);
        }
    };
    
    return {
        createRecurrence,
        loading,
        error,
    };
}
    
    export default useCreateRecurrence;